export enum continueActionTypes {
  ACCOUNT = 'ACCOUNT',
  AMOUNT = 'AMOUNT',
  TRANSFER = 'TRANSFER',
  PARTIALTRANSFER = 'PARTIALTRANSFER',
}
